/* eslint-disable */
// Generated by scripts/generate-nest-api.mjs. Do not edit by hand.
// Nest descriptor version: 2026-09-04.1

export type JsonValue = null | boolean | number | string | JsonValue[] | { [key: string]: JsonValue }

export type AppDataChangedNotification = {
    deleted?: boolean
    key: string
    namespace: string
    sessionId?: string
    version?: number
    workspaceId?: string
}

export type AppDataDeleteParams = {
    expectedVersion?: number
    key: string
    namespace: string
    scope?: AppDataScope
}

export type AppDataDeleteResult = {
    deleted: boolean
}

export type AppDataGetParams = AppDataKey

export type AppDataGetResult = {
    found: boolean
    value?: JSONValue
    version?: number
}

export type AppDataKey = {
    key: string
    namespace: string
    scope?: AppDataScope
}

export type AppDataListParams = {
    cursor?: string
    limit?: number
    namespace: string
    prefix?: string
    scope?: AppDataScope
}

export type AppDataListResult = {
    hasMore: boolean
    items: Array<AppDataRecord>
    nextCursor?: string
}

export type AppDataRecord = {
    key: string
    namespace: string
    scope: AppDataScope
    updatedAt: string
    value: JSONValue
    version: number
}

export type AppDataScope = {
    sessionId?: string
    workspaceId?: string
}

export type AppDataSetParams = {
    expectedVersion?: number
    key: string
    namespace: string
    scope?: AppDataScope
    value: JSONValue
}

export type AppDataSetResult = {
    version: number
}

export type Attachment = {
    attachmentId: string
    createdAt: string
    filename?: string
    mediaType?: string
    sha256: string
    sizeBytes: number
}

export type AttachmentDeleteParams = {
    attachmentId: string
}

export type AttachmentDeleteResult = {
    deleted: boolean
}

export type AttachmentListParams = {
    cursor?: string
    limit?: number
    sessionId?: string
}

export type AttachmentListResult = {
    hasMore: boolean
    items: Array<Attachment>
    nextCursor?: string
}

export type AttachmentReadParams = {
    attachmentId: string
}

export type AttachmentReadResult = {
    attachment: Attachment
}

export type AuditEntry = {
    at: string
    auditId: string
    decision: "allow" | "deny"
    errorCode?: string
    method: string
    operation?: AuditOperation
    preview?: string
    principalId?: string
    requestId?: string
    result: "ok" | "error"
    sequence: number
    workspaceId?: string
}

export type AuditOperation = "read" | "write" | "exec" | "stream" | "agent" | "admin" | "security"

export type AuditQueryParams = {
    cursor?: string
    fromEntryId?: string
    limit?: number
    toEntryId?: string
}

export type AuditQueryResult = {
    hasMore: boolean
    items: Array<AuditEntry>
    nextCursor?: string
}

export type AuditVerifyParams = {
    fromEntryId?: string
    toEntryId?: string
}

export type AuditVerifyResult = {
    ok: boolean
}

export type AuthGrant = {
    capability: "read" | "write" | "exec" | "agent" | "admin"
    expiresAt?: string
    scope: AuthScope
}

export type AuthPairingStartParams = {
    displayName?: string
    grants?: Array<AuthGrant>
    kind?: "person" | "device"
    meta?: JSONValue
    principalId?: string
    ttlSeconds?: number
}

export type AuthPairingStartResult = {
    code: string
    expiresAt: string
    principalId: string
}

export type AuthPrincipal = {
    displayName?: string
    grants: Array<AuthGrant>
    kind: string
    meta?: JSONValue
    paused?: boolean
    principalId: string
    tokenId?: string
}

export type AuthPrincipalDeleteParams = {
    principalId: string
}

export type AuthPrincipalDeleteResult = {
    deleted: boolean
    disconnected: number
    revokedTokens: number
}

export type AuthPrincipalListParams = PageRequest

export type AuthPrincipalListResult = {
    hasMore: boolean
    items: Array<AuthPrincipalSummary>
    nextCursor?: string
}

export type AuthPrincipalPauseParams = {
    paused: boolean
    principalId: string
}

export type AuthPrincipalPauseResult = {
    disconnected: number
    principal: AuthPrincipalSummary
}

export type AuthPrincipalReadParams = Record<string, never>

export type AuthPrincipalReadResult = AuthPrincipal

export type AuthPrincipalSummary = {
    createdAt: string
    displayName: string
    grants: Array<AuthGrant>
    kind: "person" | "device" | "local_admin"
    meta?: JSONValue
    paused: boolean
    principalId: string
    publicKey?: string
    tokens: Array<AuthToken>
    updatedAt: string
}

export type AuthPrincipalUpsertParams = {
    displayName?: string
    grants?: Array<AuthGrant>
    kind?: "person" | "device"
    meta?: JSONValue
    principalId?: string
    publicKey?: string
}

export type AuthPrincipalUpsertResult = {
    created: boolean
    disconnected: number
    principal: AuthPrincipalSummary
}

export type AuthScope = {
    type: string
    workspaceId?: string
}

export type AuthToken = {
    createdAt: string
    displayName: string
    kind: string
    principalId: string
    revoked: boolean
    tokenId: string
}

export type AuthTokenListParams = PageRequest

export type AuthTokenListResult = {
    hasMore: boolean
    items: Array<AuthToken>
    nextCursor?: string
}

export type AuthTokenRevokeParams = {
    tokenId: string
}

export type AuthTokenRevokeResult = {
    revoked: boolean
}

export type AuthTokenRevokeSelfParams = Record<string, never>

export type AuthTokenRevokeSelfResult = {
    revoked: boolean
}

export type ChangedFile = {
    binary?: boolean
    lineStats?: GitFileLineStats
    oldPath?: string
    path: string
    status: string
}

export type ClientToolCallNotification = {
    arguments: JSONValue
    callId: string
    mode?: "full" | "read-only"
    name: string
    permissionMode?: PermissionMode
    sessionId: string
    toolsetId: string
    turnId: string
}

export type ClientToolCancelNotification = {
    callId: string
}

export type ClientToolDefinition = {
    description?: string
    inputSchema: JSONValue
    name: string
}

export type ClientToolError = {
    code?: string
    message: string
}

export type ClientToolManifest = {
    tools: Array<ClientToolDefinition>
    toolsetId: string
}

export type ClientToolResultParams = {
    callId: string
    error?: ClientToolError
    result?: JSONValue
}

export type ClientToolResultResult = {
    accepted: boolean
}

export type Commit = {
    author?: string
    parentCount: number
    sha: string
    subject: string
    timestamp?: string
}

export type ContentMatch = {
    line: number
    lineNumber: number
    lineText: string
    matchEnd?: number
    matchStart?: number
    path: string
}

export type FileDescribe = {
    binary?: boolean
    children?: Array<FileEntry>
    childrenTruncated?: boolean
    content?: string
    encoding?: string
    exists: boolean
    isDir: boolean
    isSymlink?: boolean
    kind?: string
    mediaType?: string
    mode?: string
    modeBits?: number
    modifiedAt?: string
    name: string
    path: string
    sizeBytes: number
    symlinkTarget?: string
    truncated?: boolean
}

export type FileEntry = {
    isDir: boolean
    isSymlink?: boolean
    kind?: string
    mode?: string
    modeBits?: number
    modifiedAt?: string
    name: string
    path: string
    sizeBytes: number
    symlinkTarget?: string
}

export type FileMutation = {
    bytesWritten?: number
    disposition?: string
    ok: true
}

export type FilePatch = {
    generated?: boolean
    heavy: boolean
    patch: string
    stats: PatchStats
    truncated: boolean
}

export type FileRead = {
    binary: boolean
    content: string
    encoding: string
    eof?: boolean
    mediaType?: string
    nextOffset?: number
    offset: number
    sizeBytes: number
    truncated: boolean
}

export type FollowupSchedule = {
    at: string
    clientRequestId?: string
    completedAt?: string
    createdAt: string
    error?: string
    instructions: string
    note?: string
    parentScheduleId?: string
    scheduleId: string
    seriesId: string
    sessionId: string
    startedAt?: string
    state: "scheduled" | "due_waiting" | "dispatching" | "started" | "completed" | "failed" | "parked" | "cancelled"
    turnId?: string
    updatedAt: string
    version: number
    workspaceId: string
}

export type FollowupSessionSummary = {
    lastScheduleId: string
    lastStartedAt: string
    sessionId: string
    workspaceId: string
}

export type FsCopyParams = {
    cwd?: string
    fromPath: string
    toPath: string
    workspaceId: string
    worktreeId?: string
}

export type FsCopyResult = FileMutation

export type FsDescribeParams = {
    cwd?: string
    maxBytes?: number
    path: string
    readContent?: boolean
    showHidden?: boolean
    workspaceId: string
    worktreeId?: string
}

export type FsDescribeResult = FileDescribe

export type FsMkdirParams = {
    cwd?: string
    path: string
    workspaceId: string
    worktreeId?: string
}

export type FsMkdirResult = FileMutation

export type FsMoveParams = {
    cwd?: string
    fromPath: string
    toPath: string
    workspaceId: string
    worktreeId?: string
}

export type FsMoveResult = FileMutation

export type FsReadParams = {
    cwd?: string
    encoding?: "utf8" | "base64"
    maxBytes?: number
    offset?: number
    path: string
    workspaceId: string
    worktreeId?: string
}

export type FsReadResult = FileRead

export type FsRemoveParams = {
    cwd?: string
    path: string
    recursive?: boolean
    workspaceId: string
    worktreeId?: string
}

export type FsRemoveResult = FileMutation

export type FsSearchContentParams = {
    caseSensitive?: boolean
    cwd?: string
    limit?: number
    path?: string
    query: string
    regex?: boolean
    workspaceId: string
    worktreeId?: string
}

export type FsSearchContentResult = {
    matches: Array<ContentMatch>
    truncated: boolean
}

export type FsSearchFilesParams = {
    cwd?: string
    includeDirectories?: boolean
    limit?: number
    path?: string
    query: string
    workspaceId: string
    worktreeId?: string
}

export type FsSearchFilesResult = {
    directories?: Array<string>
    files: Array<string>
    truncated: boolean
    untrackedFiles?: Array<string>
}

export type FsSearchGlobParams = {
    cwd?: string
    limit?: number
    patterns: Array<string>
    workspaceId: string
    worktreeId?: string
}

export type FsSearchGlobResult = {
    matches: Array<string>
    truncated: boolean
}

export type FsWatchEventNotification = {
    op?: string
    path?: string
    relativePath?: string
    watchId: string
    workspaceId: string
    [key: string]: unknown
}

export type FsWatchListParams = {
    workspaceId?: string
}

export type FsWatchListResult = {
    watches: Array<Watch>
}

export type FsWatchOverflowNotification = {
    droppedCount?: number
    error: string
    watchId: string
    workspaceId: string
}

export type FsWatchStartParams = {
    cwd?: string
    path: string
    recursive?: boolean
    workspaceId: string
    worktreeId?: string
}

export type FsWatchStartResult = {
    watch: Watch
}

export type FsWatchStopParams = {
    watchId: string
}

export type FsWatchStopResult = {
    stopped: boolean
}

export type FsWriteFromAttachmentParams = {
    attachmentId: string
    createDirs?: boolean
    cwd?: string
    overwrite?: boolean
    path: string
    workspaceId: string
    worktreeId?: string
}

export type FsWriteFromAttachmentResult = FileMutation

export type FsWriteParams = {
    content: string
    createDirs?: boolean
    cwd?: string
    encoding?: "utf8" | "base64"
    overwrite?: boolean
    path: string
    workspaceId: string
    worktreeId?: string
}

export type FsWriteResult = FileMutation

export type GitBranch = {
    current: boolean
    name: string
    remote: boolean
    sha?: string
}

export type GitBranchDeleteParams = {
    branchName: string
    force?: boolean
    path?: string
    workspaceId: string
    worktreeId?: string
}

export type GitBranchDeleteResult = {
    deleted: boolean
}

export type GitBranchIsMergedParams = {
    branchName: string
    path?: string
    targetBranch: string
    workspaceId: string
    worktreeId?: string
}

export type GitBranchIsMergedResult = {
    merged: boolean
}

export type GitBranchListParams = {
    includeRemote?: boolean
    path?: string
    workspaceId: string
    worktreeId?: string
}

export type GitBranchListResult = {
    branches: Array<GitBranch>
    defaultBranch?: string
    defaultBranchSha?: string
}

export type GitChangedFilesParams = {
    fromTreeish: string
    path?: string
    toTreeish?: string
    workspaceId: string
    worktreeId?: string
}

export type GitChangedFilesResult = {
    files: Array<ChangedFile>
}

export type GitChangeSetSummary = {
    files: Array<ChangedFile>
    stats: GitChangeStats
}

export type GitChangeStats = {
    binaryFiles: number
    deletions: number
    filesChanged: number
    insertions: number
    unknownFiles?: number
}

export type GitCommitCherryCountParams = {
    head: string
    limit: string
    path?: string
    upstream: string
    workspaceId: string
    worktreeId?: string
}

export type GitCommitCherryCountResult = {
    available: boolean
    count: number
}

export type GitCommitCountParams = {
    from: string
    path?: string
    to: string
    workspaceId: string
    worktreeId?: string
}

export type GitCommitCountResult = {
    count: number
}

export type GitCommitCreateParams = {
    message: string
    path?: string
    workspaceId: string
    worktreeId?: string
}

export type GitCommitCreateResult =
    | {
          sha: string
          status: "committed"
      }
    | {
          reason: "nothing-to-commit"
          status: "nothing-to-commit"
      }

export type GitCommitFilesParams = {
    commit: string
    path?: string
    workspaceId: string
    worktreeId?: string
}

export type GitCommitFilesResult = {
    files: Array<ChangedFile>
}

export type GitDiffDifftasticReadParams = {
    contextLines?: number
    filePath: string
    fromTreeish: string
    maxBytes?: number
    oldPath?: string
    path?: string
    toTreeish?: string
    workspaceId: string
    worktreeId?: string
}

export type GitDiffDifftasticReadResult = {
    available: boolean
    elapsedMs: number
    error?: string
    hitTimeout: boolean
    output?: string
    truncated: boolean
}

export type GitFileAtTreeReadParams = {
    filePath: string
    maxBytes?: number
    path?: string
    treeish: string
    workspaceId: string
    worktreeId?: string
}

export type GitFileAtTreeReadResult = GitFileContent

export type GitFileContent = {
    binary: boolean
    content: string
    encoding: string
    exists: boolean
    offset: number
    sizeBytes: number
    truncated: boolean
}

export type GitFileLineStats = {
    deletions: number
    insertions: number
}

export type GitFileListParams = {
    limit?: number
    path?: string
    query?: string
    workspaceId: string
    worktreeId?: string
}

export type GitFileListResult = {
    files: Array<string>
    truncated: boolean
}

export type GitFilePairReadParams = {
    filePath: string
    fromTreeish: string
    maxBytes?: number
    oldPath?: string
    path?: string
    toTreeish?: string
    workspaceId: string
    worktreeId?: string
}

export type GitFilePairReadResult = {
    new: TreeFileContent
    old: TreeFileContent
}

export type GitGhReadParams = Record<string, never>

export type GitGhReadResult = {
    error?: string
    installed: boolean
    path?: string
    version?: string
}

export type GitInstalledReadParams = Record<string, never>

export type GitInstalledReadResult = {
    error?: string
    installed: boolean
    path?: string
    version?: string
}

export type GitLogListParams = {
    cursor?: string
    limit?: number
    path?: string
    ref?: string
    workspaceId: string
    worktreeId?: string
}

export type GitLogListResult = {
    hasMore: boolean
    items: Array<Commit>
    nextCursor?: string
}

export type GitMergeBaseReadParams = {
    from?: string
    path?: string
    to: string
    workspaceId: string
    worktreeId?: string
}

export type GitMergeBaseReadResult = {
    mergeBaseCommit: string
}

export type GitPatchCommitFileReadParams = {
    commit: string
    contextLines?: number
    filePath: string
    oldPath?: string
    path?: string
    workspaceId: string
    worktreeId?: string
}

export type GitPatchCommitFileReadResult = FilePatch

export type GitPatchWorktreeFileReadParams = {
    contextLines?: number
    filePath: string
    fromTreeish?: string
    oldPath?: string
    path?: string
    workspaceId: string
    worktreeId?: string
}

export type GitPatchWorktreeFileReadResult = FilePatch

export type GitPatchWorktreeReadParams = {
    path?: string
    workspaceId: string
    worktreeId?: string
}

export type GitPatchWorktreeReadResult = FilePatch

export type GitRepositoryInitParams = {
    path?: string
    workspaceId: string
    worktreeId?: string
}

export type GitRepositoryInitResult = {
    error?: string
    initialized: boolean
}

export type GitRepositoryPathCloneParams = {
    auth?: {
        bearerToken?: string
    }
    depth?: number
    path: string
    ref?: string
    url: string
}

export type GitRepositoryPathCloneResult = {
    defaultBranch: string
    headCommit: string
    path: string
    ref: string
    shallow: boolean
}

export type GitRepositoryPathInitParams = {
    path: string
}

export type GitRepositoryPathInitResult = {
    error?: string
    initialized: boolean
}

export type GitRepositoryPathReadParams = {
    path: string
}

export type GitRepositoryPathReadResult = {
    branch?: string
    isRepo: boolean
    root?: string
}

export type GitRepositoryReadParams = {
    path?: string
    workspaceId: string
    worktreeId?: string
}

export type GitRepositoryReadResult = {
    branch?: string
    isRepo: boolean
    root?: string
}

export type GitStatus = {
    patch?: string
    raw: string
    stagedPatch?: string
    summary: GitSummary
    unstagedPatch?: string
}

export type GitStatusReadParams = {
    includePatch?: boolean
    path?: string
    workspaceId: string
    worktreeId?: string
}

export type GitStatusReadResult = GitStatus

export type GitStatusSummaryParams = {
    path?: string
    workspaceId: string
    worktreeId?: string
}

export type GitStatusSummaryResult = GitSummary

export type GitSummary = {
    ahead?: number
    branch?: string
    clean: boolean
    headCommit?: string
    raw: string
    staged: GitChangeSetSummary
    total: GitChangeStats
    unstaged: GitChangeSetSummary
    untracked: GitChangeSetSummary
}

export type GitWorktreeCreateParams = {
    branchName?: string
    checkout?: WorktreeCheckout
    path?: string
    sourceTreeish?: string
    workspaceId: string
    worktreeId?: string
    worktreePath: string
}

export type GitWorktreeCreateResult = {
    branchCreated?: boolean
    created: boolean
    disposition?: "created" | "reused"
    sourceCommit?: string
    warnings?: Array<WorktreeWarning>
    worktree: Worktree
}

export type GitWorktreeDeleteParams = {
    force?: boolean
    path?: string
    workspaceId: string
    worktreeId: string
}

export type GitWorktreeDeleteResult = {
    deleted: boolean
}

export type GitWorktreeListParams = {
    path?: string
    workspaceId: string
    worktreeId?: string
}

export type GitWorktreeListResult = {
    worktrees: Array<Worktree>
}

export type HostBinary = {
    checkedAt: string
    command: string
    error?: string
    found: boolean
    path?: string
    version?: string
}

export type HostBinaryCheckParams = {
    command: string
}

export type HostBinaryCheckResult = HostBinary

export type HostBinaryListParams = Record<string, never>

export type HostBinaryListResult = {
    binaries: Array<HostBinary>
}

export type HostCPU = {
    sampledAt: string
    usedPercent: number
    windowMs: number
}

export type HostFile = {
    binary?: boolean
    children?: Array<HostFileChild>
    childrenTruncated?: boolean
    content?: string
    encoding?: string
    exists: boolean
    isDir: boolean
    isSymlink?: boolean
    kind?: string
    mediaType?: string
    mode?: string
    modeBits?: number
    modifiedAt?: string
    name: string
    path: string
    sizeBytes: number
    symlinkTarget?: string
    truncated?: boolean
}

export type HostFileChild = {
    isDir: boolean
    isSymlink?: boolean
    kind?: string
    mode?: string
    modeBits?: number
    modifiedAt?: string
    name: string
    path: string
    sizeBytes: number
    symlinkTarget?: string
}

export type HostFileDescribeParams = {
    maxBytes?: number
    path: string
    readContent?: boolean
    showHidden?: boolean
}

export type HostFileDescribeResult = HostFile

export type HostMemory = {
    availableBytes: number
    sampledAt: string
    totalBytes: number
    usedBytes: number
    usedPercent: number
}

export type HostPathMkdirParams = {
    path: string
}

export type HostPathMkdirResult = HostResolvedPath

export type HostPathResolveParams = {
    path: string
}

export type HostPathResolveResult = HostResolvedPath

export type HostPlatform = {
    arch: string
    homeDir?: string
    listSeparator: string
    pathSeparator: string
    platform: string
    tempDir?: string
}

export type HostPlatformReadParams = Record<string, never>

export type HostPlatformReadResult = HostPlatform

export type HostResolvedPath = {
    abs: string
    baseName: string
    clean: string
    exists: boolean
    input: string
    isDir: boolean
    isSymlink?: boolean
    kind?: string
    mode?: string
    modeBits?: number
    modifiedAt?: string
    symlinkTarget?: string
    volume?: string
}

export type HostResources = {
    cpu?: HostCPU
    memory?: HostMemory
}

export type JSONValue = unknown

export type Listener = {
    addr: string
    certPem?: string
    keyPem?: string
    name: string
    tls: boolean
}

export type ListenerCreateParams = {
    addr: string
    certPem?: string
    keyPem?: string
    name: string
    tls?: boolean
}

export type ListenerCreateResult = {
    listener: Listener
}

export type ListenerDeleteParams = {
    listenerName: string
}

export type ListenerDeleteResult = {
    deleted: boolean
}

export type ListenerListParams = Record<string, never>

export type ListenerListResult = {
    listeners: Array<Listener>
}

export type ListenerUpdateParams = {
    addr: string
    certPem?: string
    keyPem?: string
    name: string
    tls: boolean
}

export type ListenerUpdateResult = {
    listener: Listener
}

export type MethodDescriptor = {
    cancellable?: boolean
    name: string
    operation: AuditOperation
    paramsSchemaRef: string
    requiredCapabilities?: Array<string>
    requiredCapability: string
    resultSchemaRef: string
    scope: MethodScope
}

export type MethodScope = {
    param?: string
    resolvesTo?: string
    resourceParam?: string
    type: string
}

export type NativeSessionDiagnostic = {
    code: string
    message: string
    path?: string
    providerId: string
    severity: string
}

export type NativeSessionDiscoveryItem = {
    createdAt?: string
    cwd: string
    materialized: boolean
    model?: string
    providerId: string
    providerSessionId: string
    repositoryRoot?: string
    sessionFile: string
    sessionId: string
    sessionRoot: string
    status: string
    title?: string
    updatedAt?: string
    workspaceId?: string
    workspaceRegistered: boolean
}

export type NativeSessionDiscoveryRefresh = {
    errors: Array<string>
    failed: number
    lastCompletedAt?: string
    pending: number
    requested: number
    state: "indexing" | "ready" | "degraded"
    succeeded: number
}

export type Notification = {
    cursor?: string
    method: string
    params: JSONValue
}

export type NotificationDescriptor = {
    name: string
    paramsSchemaRef: string
}

export type OutputChunk = {
    data: string
    encoding: "utf8" | "base64"
    offset: number
    stream: "stdout" | "stderr" | "pty"
    timestamp: string
}

export type OutputReadParams = {
    maxBytes?: number
    offset?: number
    processId?: string
    runtimeId?: string
    terminalId?: string
}

export type PageRequest = {
    cursor?: string
    limit?: number
}

export type PageResult = {
    hasMore?: boolean
    items: Array<JSONValue>
    nextCursor?: string
}

export type PatchStats = {
    changedLines: number
    deletions: number
    hunkCount: number
    insertions: number
}

export type PermissionDecision = "allow" | "deny"

export type PermissionMode = "ask" | "auto" | "yolo"

export type PermissionRequestNotification = {
    blockedPath?: string
    command?: string
    cwd?: string
    description?: string
    input: JSONValue
    kind: "tool" | "command" | "file-change" | "permissions"
    mode: PermissionMode
    providerId: string
    reason?: string
    requestId: string
    review?: PermissionReview
    sessionId: string
    title?: string
    toolName?: string
    turnId: string
    workspaceId: string
}

export type PermissionRespondParams = {
    decision: PermissionDecision
    message?: string
    requestId: string
    sessionId: string
}

export type PermissionRespondResult = {
    accepted: boolean
}

export type PermissionReview = {
    decision: PermissionDecision
    decisionSource?: string
    rationale?: string
    riskLevel?: "low" | "medium" | "high" | "critical"
    userAuthorization?: "unknown" | "low" | "medium" | "high"
}

export type ProcessBatchStartParams = {
    cwd: string
    labels?: {
        [key: string]: string
    }
    namespace: string
    processes: Array<{
        args?: Array<string>
        command?: string
        cwd?: string
        env?: {
            [key: string]: string
        }
        name: string
        port?: ProcessPort
        script?: string
        shell?: string
        timeoutMs?: number
    }>
}

export type ProcessBatchStartResult = {
    failed: number
    firstErrors: Array<string>
    requested: number
    results: Array<{
        error?: string
        name: string
        process?: RuntimeRecord
    }>
    status: "done" | "done-with-gaps"
    succeeded: number
}

export type ProcessCommandStartParams = RuntimeStartRequest

export type ProcessCommandStartResult = {
    process: RuntimeRecord
}

export type ProcessExitedNotification = {
    commandPreview?: string
    completedAt?: string
    cwd?: string
    data?: JSONValue
    exitCode?: number
    kind?: "session" | "process" | "terminal" | "watch"
    label?: string
    processId?: string
    runtimeId: string
    startedAt?: string
    status?: "starting" | "running" | "completed" | "failed" | "stopped"
    terminalId?: string
    updatedAt?: string
    workspaceId?: string
    worktreeId?: string
    [key: string]: unknown
}

export type ProcessListParams = {
    cursor?: string
    limit?: number
    namespace?: string
    status?: "active" | "starting" | "running" | "stopped" | "failed" | "completed"
    workspaceId?: string
}

export type ProcessListResult = {
    nextCursor?: string
    processes: Array<RuntimeRecord>
}

export type ProcessOutputNotification = {
    chunk: OutputChunk
    processId: string
    runtimeId: string
    terminalId?: string
    workspaceId?: string
}

export type ProcessOutputReadParams = OutputReadParams

export type ProcessOutputReadResult = RuntimeOutputRead

export type ProcessPort = number

export type ProcessReadParams = {
    processId: string
}

export type ProcessReadResult = {
    process: RuntimeRecord
}

export type ProcessRestartParams = {
    processId: string
}

export type ProcessRestartResult = {
    process: RuntimeRecord
}

export type ProcessScriptStartParams = RuntimeStartRequest

export type ProcessScriptStartResult = {
    process: RuntimeRecord
}

export type ProcessStartedNotification = {
    commandPreview?: string
    completedAt?: string
    cwd?: string
    data?: JSONValue
    exitCode?: number
    kind?: "session" | "process" | "terminal" | "watch"
    label?: string
    processId?: string
    runtimeId: string
    startedAt?: string
    status?: "starting" | "running" | "completed" | "failed" | "stopped"
    terminalId?: string
    updatedAt?: string
    workspaceId?: string
    worktreeId?: string
    [key: string]: unknown
}

export type ProcessStopAllParams = {
    workspaceId?: string
}

export type ProcessStopAllResult = {
    failed?: number
    firstErrors?: Array<string>
    requested?: number
    status?: "done" | "done-with-gaps"
    stopped: number
    succeeded?: number
}

export type ProcessStopParams = {
    processId: string
    signal?: string
}

export type ProcessStoppedNotification = {
    commandPreview?: string
    completedAt?: string
    cwd?: string
    data?: JSONValue
    exitCode?: number
    kind?: "session" | "process" | "terminal" | "watch"
    label?: string
    processId?: string
    runtimeId: string
    startedAt?: string
    status?: "starting" | "running" | "completed" | "failed" | "stopped"
    terminalId?: string
    updatedAt?: string
    workspaceId?: string
    worktreeId?: string
    [key: string]: unknown
}

export type ProcessStopResult = {
    stopped: boolean
}

export type ProviderAccountCredits = {
    currency?: string
    limit?: number
    manualResetsAvailable?: number
    nextManualResetExpiresAt?: string
    remaining?: number
    resetsAt?: string
    unlimited?: boolean
    used?: number
}

export type ProviderAccountIdentity = {
    email?: string
    id?: string
    organization?: string
    plan?: string
}

export type ProviderAccountLimit = {
    id: string
    isSyntheticPlaceholder?: boolean
    kind: "session" | "weekly" | "monthly" | "special"
    label: string
    model?: string
    pace?: ProviderAccountUsagePace
    percentLeft?: number
    resetDescription?: string
    resetsAt?: string
    startsAt?: string
    usageKnown: boolean
    usedPercent?: number
    windowMinutes?: number
}

export type ProviderAccountUsage = {
    account?: ProviderAccountIdentity
    credits?: ProviderAccountCredits
    diagnostics?: Array<ProviderAccountUsageDiagnostic>
    limits: Array<ProviderAccountLimit>
    limitsUpdatedAt?: string
    message?: string
    periods: Array<ProviderAccountUsagePeriod>
    periodsUpdatedAt?: string
    providerId: string
    scan?: ProviderAccountUsageScanStats
    source: "provider" | "local" | "mixed" | "unknown"
    status: "available" | "partial" | "unavailable"
    updatedAt: string
}

export type ProviderAccountUsageDiagnostic = {
    code: string
    message: string
    source: string
}

export type ProviderAccountUsagePace = {
    actualUsedPercent: number
    deficitPercent?: number
    deltaPercent: number
    expectedUsedPercent: number
    lastsUntilReset: boolean
    projectedEmptyAt?: string
    reservePercent?: number
    state: "on_track" | "reserve" | "deficit"
}

export type ProviderAccountUsagePeriod = {
    costUsd?: number
    end: string
    id: string
    models?: Array<string>
    requests?: number
    start: string
    tokens?: ProviderAccountUsageTokens
}

export type ProviderAccountUsageReadParams = {
    now?: string
    periods?: Array<
        | {
              end: string
              id?: string
              start: string
          }
        | Array<string>
    >
    providerId: string
    refresh?: boolean
}

export type ProviderAccountUsageReadResult = {
    usage: ProviderAccountUsage
}

export type ProviderAccountUsageScanStats = {
    failedFiles: number
    firstErrors?: Array<string>
    requestedFiles: number
    succeededFiles: number
}

export type ProviderAccountUsageTokens = {
    cacheRead?: number
    cacheWrite?: number
    input?: number
    output?: number
    total?: number
}

export type ProviderCapabilities = {
    appendSystemPrompt: boolean
    attachments: boolean
    clientTools: boolean
    contextUpdates?: boolean
    fork: boolean
    images: boolean
    mcp: boolean
    permissionModes: Array<PermissionMode>
    readOnly: boolean
    resume: boolean
    sessionReplay: boolean
    steering: boolean
    structuredOutput: boolean
    systemPrompt: boolean
}

export type ProviderCommand = {
    description?: string
    name: string
}

export type ProviderCommandListParams = {
    providerId: string
    workspaceId?: string
}

export type ProviderCommandListResult = {
    commands: Array<ProviderCommand>
}

export type ProviderListParams = Record<string, never>

export type ProviderListResult = {
    providers: Array<ProviderSummary>
}

export type ProviderModel = {
    capabilities?: ProviderModelCapabilities
    class?: string
    default?: boolean
    displayClass?: string
    fullId?: string
    label?: string
    latest?: boolean
    legacy?: boolean
    limits?: ProviderModelLimits
    modelId: string
    nativeProvider?: string
    pricing?: ProviderModelPricing
    releaseDate?: string
    selector?: string
    status?: string
    tier?: string
    variants?: Array<string>
}

export type ProviderModelCapabilities = {
    attachments: boolean
    images: boolean
    pdfs: boolean
    reasoning: boolean
    tools: boolean
}

export type ProviderModelLimits = {
    contextTokens?: number
    inputTokens?: number
    outputTokens?: number
}

export type ProviderModelListParams = {
    providerId: string
}

export type ProviderModelListResult = {
    models: Array<ProviderModel>
}

export type ProviderModelPricing = {
    cacheReadPerMillionUsd?: number
    cacheWritePerMillionUsd?: number
    inputPerMillionUsd?: number
    outputPerMillionUsd?: number
    tiered?: boolean
}

export type ProviderQueryRunParams = {
    appendSystemPrompt?: string
    model?: string
    prompt: string
    providerId: string
    timeoutMs?: number
}

export type ProviderQueryRunResult = {
    diagnostics?: Array<NativeSessionDiagnostic>
    providerSessionId?: string
    text: string
}

export type ProviderStatusParams = {
    providerId: string
}

export type ProviderStatusResult = {
    provider: ProviderSummary
}

export type ProviderSummary = {
    authenticated: boolean
    available: boolean
    capabilities: ProviderCapabilities
    installed: boolean
    label: string
    models?: Array<ProviderModel>
    providerId: string
    statusMessage?: string
    version?: string
}

export type ProviderUpdateBatchResult = {
    errors?: Array<string>
    failed: number
    requested: number
    results: Array<ProviderUpdateResult>
    succeeded: number
}

export type ProviderUpdateResult = {
    command: string
    completedAt: string
    currentVersion?: string
    durationMs: number
    error?: string
    label: string
    output?: string
    previousVersion?: string
    providerId: string
    startedAt: string
    status: "unavailable" | "updated" | "current" | "failed"
    updated: boolean
}

export type ProviderUpdateRunParams = {
    providerId?: string
}

export type ProviderUpdateRunResult = {
    update: ProviderUpdateBatchResult
}

export type RpcError = {
    code: string
    data?: JSONValue
    message: string
}

export type RuntimeListParams = {
    kind?: "session" | "process" | "terminal" | "watch"
    status?: "starting" | "running" | "completed" | "failed" | "stopped"
}

export type RuntimeListResult = {
    runtimes: Array<RuntimeRecord>
}

export type RuntimeOutputNotification = {
    chunk: OutputChunk
    processId?: string
    runtimeId: string
    terminalId?: string
    workspaceId?: string
}

export type RuntimeOutputRead = {
    chunks: Array<OutputChunk>
    droppedBeforeOffset?: number
    nextOffset: number
    offsetUnit?: "chunk"
    truncated: boolean
}

export type RuntimeReadParams = {
    runtimeId: string
}

export type RuntimeReadResult = {
    runtime: RuntimeRecord
}

export type RuntimeRecord = {
    commandPreview?: string
    completedAt?: string
    cwd?: string
    data?: {
        [key: string]: unknown
    }
    exitCode?: number
    kind: "session" | "process" | "terminal" | "watch"
    label?: string
    labels?: {
        [key: string]: string
    }
    name?: string
    namespace?: string
    pid?: number
    port?: ProcessPort
    processId?: string
    restartable?: boolean
    runtimeId: string
    startedAt: string
    status: "starting" | "running" | "completed" | "failed" | "stopped"
    terminalId?: string
    updatedAt: string
    workspaceId?: string
    worktreeId?: string
}

export type RuntimeStartRequest = {
    args?: Array<string>
    clientRequestId?: string
    cols?: number
    command?: string
    cwd?: string
    env?: {
        [key: string]: string
    }
    label?: string
    labels?: {
        [key: string]: string
    }
    name?: string
    namespace?: string
    port?: ProcessPort
    rows?: number
    script?: string
    shell?: string
    timeoutMs?: number
    workspaceId?: string
    worktreeId?: string
}

export type Schedule = {
    at: string
    createdAt: string
    firedAt?: string
    payload: JSONValue
    scheduleId: string
}

export type ScheduleCreateParams = {
    at: string
    payload: JSONValue
}

export type ScheduleCreateResult = {
    schedule: Schedule
}

export type ScheduleDeleteParams = {
    scheduleId: string
}

export type ScheduleDeleteResult = {
    deleted: boolean
}

export type ScheduleFiredNotification = {
    firedAt: string
    payload: JSONValue
    scheduledAt: string
    scheduleId: string
}

export type ScheduleFollowupCancelAllParams = {
    sessionId: string
}

export type ScheduleFollowupCancelAllResult = {
    errors: Array<string>
    failed: number
    requested: number
    succeeded: number
}

export type ScheduleFollowupCancelParams = {
    expectedVersion?: number
    scheduleId: string
    sessionId: string
}

export type ScheduleFollowupCancelResult = {
    cancelled: boolean
}

export type ScheduleFollowupCreateParams = {
    at: string
    clientRequestId?: string
    inheritActiveTurn?: boolean
    instructions: string
    location?: {
        cwd?: string
        worktreeId?: string
    }
    note?: string
    options?: TurnOptions
    sessionId: string
}

export type ScheduleFollowupCreateResult = {
    schedule: FollowupSchedule
}

export type ScheduleFollowupListParams = {
    cursor?: string
    limit?: number
    schedulesDone?: boolean
    sessionId?: string
    sessionIds?: Array<string>
    summariesDone?: boolean
    summaryCursor?: string
    workspaceId?: string
}

export type ScheduleFollowupListResult = {
    hasMore: boolean
    hasMoreSummaries: boolean
    nextCursor?: string
    nextSummaryCursor?: string
    schedules: Array<FollowupSchedule>
    sessionSummaries: Array<FollowupSessionSummary>
}

export type ScheduleFollowupReadParams = {
    scheduleId: string
    sessionId: string
}

export type ScheduleFollowupReadResult = {
    schedule: FollowupSchedule
}

export type ScheduleFollowupRunNowParams = {
    expectedVersion?: number
    scheduleId: string
    sessionId: string
}

export type ScheduleFollowupRunNowResult = {
    schedule: FollowupSchedule
}

export type ScheduleFollowupUpdateParams = {
    at?: string
    expectedVersion?: number
    instructions?: string
    note?: string
    scheduleId: string
    sessionId: string
}

export type ScheduleFollowupUpdateResult = {
    schedule: FollowupSchedule
}

export type ScheduleListParams = {
    limit?: number
}

export type ScheduleListResult = {
    schedules: Array<Schedule>
}

export type ScheduleUpdatedNotification = {
    schedule: FollowupSchedule
    scheduleId: string
    sessionId: string
    workspaceId: string
}

export type Session = {
    activeTurnId?: string
    createdAt: string
    cwd?: string
    eventCount: number
    lastEventPreview?: string
    lastInputPreview?: string
    model?: string
    origin?: string
    providerId: string
    providerSessionId?: string
    queuedTurnIds: Array<string>
    sessionFile?: string
    sessionId: string
    sessionRoot?: string
    spawnedBy?: SpawnedBy
    status: string
    storageState?: string
    title?: string
    updatedAt: string
    workspaceId: string
    worktreeId?: string
}

export type SessionContextReadParams = {
    sessionId: string
}

export type SessionContextReadResult = {
    revision: number
    sessionId: string
    values: {
        [key: string]: string
    }
}

export type SessionContextSetParams = {
    content: unknown
    expectedRevision?: number
    key: string
    sessionId: string
}

export type SessionContextSetResult = {
    changed: boolean
    revision: number
    sessionId: string
    values: {
        [key: string]: string
    }
}

export type SessionCreatedNotification = {
    error?: string
    session: JSONValue
    sessionId: string
    status?: string
    workspaceId: string
}

export type SessionCreateParams = {
    cwd?: string
    model?: string
    providerId: string
    providerSessionId?: string
    spawnedBy?: SpawnedBy
    workspaceId: string
    worktreeId?: string
}

export type SessionCreateResult = {
    session: Session
}

export type SessionDeletedNotification = {
    sessionId: string
    workspaceId?: string
}

export type SessionDeleteParams = {
    sessionId: string
}

export type SessionDeleteResult = {
    deleted: boolean
}

export type SessionDiscoverParams = {
    cursor?: string
    directory?: string
    excludeSessionIds?: Array<string>
    limit?: number
    providerIds?: Array<string>
    refresh?: boolean
    workspaceId?: string
}

export type SessionDiscoverResult = {
    hasMore: boolean
    items: Array<NativeSessionDiscoveryItem>
    nextCursor?: string
    refresh: NativeSessionDiscoveryRefresh
}

export type SessionEvent = {
    eventId: string
    providerEventId?: string
    providerId: string
    providerSessionId?: string
    raw: JSONValue
    receivedAt: string
    sequence: number
    sessionId: string
    source: string
    turnId?: string
}

export type SessionEventAppendedNotification = {
    event: SessionEvent
    sessionId: string
    turnId?: string
    workspaceId: string
}

export type SessionEventListParams = {
    afterSequence?: number
    cursor?: string
    limit?: number
    maxBytes?: number
    oldestFirst?: boolean
    sessionId: string
}

export type SessionEventListResult = {
    hasMore: boolean
    items: Array<SessionEvent>
    nextCursor?: string
}

export type SessionEventSearchDeleteParams = {
    sessionIds: Array<string>
}

export type SessionEventSearchDeleteResult = {
    errors: Array<string>
    failed: number
    requested: number
    succeeded: number
}

export type SessionEventSearchHit = {
    occurredAt?: string
    preview: string
    providerEventId?: string
    providerId: string
    providerSessionId?: string
    role: "user" | "assistant"
    score: number
    sequence: number
    sessionId: string
    workspaceId: string
}

export type SessionEventSearchParams = {
    limit?: number
    query: string
    workspaceId?: string
}

export type SessionEventSearchRefresh = {
    errors: Array<string>
    failed: number
    lastCompletedAt?: string
    pending: number
    requested: number
    state: "indexing" | "ready" | "degraded"
    succeeded: number
}

export type SessionEventSearchResult = {
    items: Array<SessionEventSearchHit>
    refresh: SessionEventSearchRefresh
}

export type SessionForkParams = {
    model?: string
    sessionId: string
    workspaceId?: string
}

export type SessionForkResult = {
    session: Session
}

export type SessionListParams = {
    cursor?: string
    limit?: number
    spawnedBy?: SpawnedBy
    workspaceId?: string
}

export type SessionListResult = {
    diagnostics?: Array<NativeSessionDiagnostic>
    discoveryRefresh?: NativeSessionDiscoveryRefresh
    hasMore: boolean
    items: Array<Session>
    nextCursor?: string
    workspaceCandidates?: Array<WorkspaceDiscoveryItem>
}

export type SessionOutput = {
    finalMessage: string
    transcriptPath: string
}

export type SessionOutputReadParams = {
    sessionId: string
}

export type SessionOutputReadResult = SessionOutput

export type SessionReadParams = {
    sessionId: string
}

export type SessionReadResult = {
    session: Session
}

export type SessionReconciledNotification = {
    appendedEvents: number
    queuedTurnCount?: number
    session?: JSONValue
    sessionId: string
    workspaceId: string
}

export type SessionReconcileParams = {
    sessionId: string
}

export type SessionReconcileResult = {
    appendedEvents: number
    session: Session
}

export type SessionTurnCancelParams = {
    turnId: string
}

export type SessionTurnCancelResult = {
    cancelled: boolean
}

export type SessionTurnInterruptParams = {
    reason?: string
    turnId: string
}

export type SessionTurnInterruptResult = {
    interrupted: boolean
}

export type SessionTurnListParams = {
    sessionId: string
}

export type SessionTurnListResult = {
    turns: Array<Turn>
}

export type SessionTurnLiveListParams = Record<string, never>

export type SessionTurnLiveListResult = {
    turns: Array<Turn>
}

export type SessionTurnReadParams = {
    turnId: string
}

export type SessionTurnReadResult = {
    turn: Turn
}

export type SessionTurnStartParams = {
    clientRequestId?: string
    disposition?: "enqueue" | "steer" | "interrupt" | "reject"
    ifBusy?: "enqueue" | "reject"
    input: TurnInput
    options?: TurnOptions
    sessionId: string
}

export type SessionTurnStartResult = {
    effectiveDisposition: "started" | "enqueued" | "steered" | "interrupted"
    queued: boolean
    session: Session
    turn: Turn
}

export type SessionTurnSteerParams = {
    input: TurnInput
    sessionId: string
    turnId: string
}

export type SessionTurnSteerResult = {
    accepted: boolean
}

export type SessionTurnUpdatedNotification = {
    cancelled?: boolean
    completed?: boolean
    error?: string
    interrupted?: boolean
    providerData?: JSONValue
    queued?: boolean
    sessionId?: string
    status?: string
    steered?: boolean
    terminal?: boolean
    turn?: JSONValue
    turnId: string
    workspaceId?: string
}

export type SessionUpdatedNotification = {
    error?: string
    session?: JSONValue
    sessionId: string
    status?: string
    workspaceId: string
}

export type SessionUpdateParams = {
    cwd?: string
    sessionId: string
    worktreeId?: string
}

export type SessionUpdateResult = {
    session: Session
}

export type SessionUsage = {
    cacheReadTokens?: number
    cacheWriteTokens?: number
    durationMs?: number
    estimatedCostUsd?: number
    eventCount: number
    inputTokens: number
    model?: string
    outputTokens: number
    pricingVersion?: string
    providerId: string
    providerSessionId?: string
    reportedCostUsd?: number
    source: SessionUsageSource
}

export type SessionUsageReadParams = {
    sessionId: string
}

export type SessionUsageReadResult = {
    usage: SessionUsage
}

export type SessionUsageSource = {
    cost: "provider" | "estimated" | "unavailable"
    duration: "provider" | "nest_turn" | "timestamp_estimate" | "unavailable"
    tokens: "provider" | "derived" | "unavailable"
}

export type SessionWorktreeCreateParams = {
    clientRequestId: string
    model?: string
    providerId: string
    workspaceId: string
    worktree: WorktreeRequest
}

export type SessionWorktreeCreateResult = {
    branchCreated: boolean
    disposition: "created" | "reused"
    session: Session
    sourceCommit: string
    warnings: Array<WorktreeWarning>
    workingChanges?: WorktreeWorkingChangesResult
    worktree: Worktree
}

export type SessionWorktreeMoveParams = {
    sessionId: string
    worktree: WorktreeRequest
}

export type SessionWorktreeMoveResult = {
    branchCreated: boolean
    disposition: "created" | "reused"
    session: Session
    sourceCommit: string
    warnings: Array<WorktreeWarning>
    workingChanges?: WorktreeWorkingChangesResult
    worktree: Worktree
}

export type SpawnedBy = {
    id: string
    kind: string
}

export type SubscriptionFilter = {
    appDataNamespace?: string
    appDataPrefix?: string
    appDataScope?: {
        sessionId?: string
        workspaceId?: string
    }
    method?: string
    processId?: string
    runtimeId?: string
    sessionId?: string
    terminalId?: string
    turnId?: string
    watchId?: string
    workspaceId?: string
}

export type SystemCapabilitiesReadParams = Record<string, never>

export type SystemCapabilitiesReadResult = {
    features: {
        [key: string]: boolean
    }
    limits: JSONValue
    methods: Array<string>
    notifications: Array<string>
    providers: Array<ProviderSummary>
}

export type SystemDescriptor = {
    descriptorVersion: string
    errorCodes: Array<string>
    methods: Array<MethodDescriptor>
    name: string
    notificationDescriptors: Array<NotificationDescriptor>
    notifications: Array<string>
    protocolVersion: number
    schemas: {
        [key: string]: JSONValue
    }
}

export type SystemDescriptorReadParams = Record<string, never>

export type SystemDescriptorReadResult = SystemDescriptor

export type SystemInitializeParams = {
    clientName?: string
    clientPlatform?: "cli" | "web" | "desktop" | "mobile" | "unknown"
    clientVersion?: string
    protocolVersion: number
}

export type SystemInitializeResult = {
    authenticated: boolean
    capabilities: SystemCapabilitiesReadResult
    descriptorVersion: string
    nodeId: string
    nodeName: string
    principal: AuthPrincipal
    protocolVersion: number
    serverVersion: string
}

export type SystemMetrics = {
    activeProcesses: number
    activeSessions: number
    activeTerminals: number
    activeWatches: number
    bufferedBytes: number
    databaseBytes: number
    hostResources?: HostResources
    methodTimings: {
        [key: string]: JSONValue
    }
    openSockets: number
    queuedTurns: number
    replayBytes: number
}

export type SystemMetricsReadParams = Record<string, never>

export type SystemMetricsReadResult = SystemMetrics

export type SystemRequestCancelParams = {
    requestId: string
}

export type SystemRequestCancelResult = {
    cancelled: boolean
}

export type SystemStatusReadParams = Record<string, never>

export type SystemStatusReadResult = {
    databasePath: string
    defaultWorkspaceId: string
    listeners: Array<Listener>
    nodeId: string
    nodeName: string
    uptimeSeconds: number
    version: string
}

export type SystemSubscriptionUpdateParams = {
    cursor?: string
    subscriptions?: Array<SubscriptionFilter>
}

export type SystemSubscriptionUpdateResult = {
    cursor: string
    subscriptions: Array<SubscriptionFilter>
}

export type TerminalExitedNotification = {
    commandPreview?: string
    completedAt?: string
    cwd?: string
    data?: JSONValue
    exitCode?: number
    kind?: "session" | "process" | "terminal" | "watch"
    label?: string
    processId?: string
    runtimeId: string
    startedAt?: string
    status?: "starting" | "running" | "completed" | "failed" | "stopped"
    terminalId?: string
    updatedAt?: string
    workspaceId?: string
    worktreeId?: string
    [key: string]: unknown
}

export type TerminalListParams = {
    workspaceId?: string
}

export type TerminalListResult = {
    terminals: Array<RuntimeRecord>
}

export type TerminalOutputNotification = {
    chunk: OutputChunk
    processId?: string
    runtimeId: string
    terminalId: string
    workspaceId?: string
}

export type TerminalReadParams = OutputReadParams

export type TerminalReadResult = RuntimeOutputRead

export type TerminalResizeParams = {
    cols: number
    rows: number
    terminalId: string
}

export type TerminalResizeResult = {
    ok: true
}

export type TerminalSpawnParams = RuntimeStartRequest

export type TerminalSpawnResult = {
    terminal: RuntimeRecord
}

export type TerminalStartedNotification = {
    commandPreview?: string
    completedAt?: string
    cwd?: string
    data?: JSONValue
    exitCode?: number
    kind?: "session" | "process" | "terminal" | "watch"
    label?: string
    processId?: string
    runtimeId: string
    startedAt?: string
    status?: "starting" | "running" | "completed" | "failed" | "stopped"
    terminalId?: string
    updatedAt?: string
    workspaceId?: string
    worktreeId?: string
    [key: string]: unknown
}

export type TerminalStopParams = {
    terminalId: string
}

export type TerminalStoppedNotification = {
    commandPreview?: string
    completedAt?: string
    cwd?: string
    data?: JSONValue
    exitCode?: number
    kind?: "session" | "process" | "terminal" | "watch"
    label?: string
    processId?: string
    runtimeId: string
    startedAt?: string
    status?: "starting" | "running" | "completed" | "failed" | "stopped"
    terminalId?: string
    updatedAt?: string
    workspaceId?: string
    worktreeId?: string
    [key: string]: unknown
}

export type TerminalStopResult = {
    stopped: boolean
}

export type TerminalWriteParams = {
    data: string
    encoding?: "utf8" | "base64"
    terminalId: string
}

export type TerminalWriteResult = {
    ok: true
}

export type TreeFileContent = {
    content: string
    encoding: string
    exists: boolean
    truncated: boolean
}

export type Turn = {
    clientRequestId?: string
    completedAt?: string
    error?: string
    input: JSONValue
    queuedAt?: string
    sessionId: string
    startedAt?: string
    status: string
    turnId: string
    usage?: JSONValue
}

export type TurnInput = {
    parts: Array<
        | {
              text: string
              type: "text"
          }
        | {
              attachmentId: string
              type: "attachment"
          }
    >
}

export type TurnOptions = {
    additionalDirs?: Array<string>
    appendSystemPrompt?: string
    clientTools?: ClientToolManifest
    contextRevision?: number
    cwd?: string
    mode?: string
    model?: string
    permissionMode?: PermissionMode
    providerOptions?: {
        [key: string]: unknown
    }
    systemPrompt?: string
    worktreeId?: string
}

export type Watch = {
    events?: Array<string>
    path: string
    recursive: boolean
    watchId: string
    workspaceId: string
}

export type Workspace = {
    createdAt: string
    default: boolean
    name: string
    primaryDir: string
    updatedAt: string
    workspaceId: string
}

export type WorkspaceCreateParams = {
    clientRequestId?: string
    name?: string
    primaryDir?: string
}

export type WorkspaceCreateResult = {
    workspace: Workspace
}

export type WorkspaceDeleteParams = {
    workspaceId: string
}

export type WorkspaceDeleteResult = {
    deleted: boolean
}

export type WorkspaceDiscoverParams = {
    cursor?: string
    excludeSessionIds?: Array<string>
    includeOtherLocations?: boolean
    limit?: number
}

export type WorkspaceDiscoverResult = {
    diagnostics: Array<NativeSessionDiagnostic>
    hasMore: boolean
    items: Array<WorkspaceDiscoveryItem>
    nextCursor?: string
    refresh: NativeSessionDiscoveryRefresh
}

export type WorkspaceDiscoveryItem = {
    lastSessionId?: string
    lastSessionTitle?: string
    lastSessionUpdatedAt?: string
    name: string
    primaryDir: string
    providerIds: Array<string>
    registered: boolean
    sessionCount: number
    workspaceId?: string
}

export type WorkspaceListParams = PageRequest

export type WorkspaceListResult = {
    hasMore: boolean
    items: Array<Workspace>
    nextCursor?: string
}

export type WorkspaceReadParams = {
    workspaceId: string
}

export type WorkspaceReadResult = {
    workspace: Workspace
}

export type WorkspaceRegisterParams = {
    clientRequestId?: string
    name?: string
    primaryDir: string
}

export type WorkspaceRegisterResult = {
    disposition: "created" | "reused"
    workspace: Workspace
}

export type WorkspaceUpdatedNotification = {
    deleted?: boolean
    workspace?: JSONValue
    workspaceId: string
}

export type WorkspaceUpdateParams = {
    name?: string
    primaryDir?: string
    workspaceId: string
}

export type WorkspaceUpdateResult = {
    workspace: Workspace
}

export type Worktree = {
    branch?: string
    head?: string
    path: string
    worktreeId: string
}

export type WorktreeCheckout =
    | {
          branchName: string
          existingTarget: "error" | "reuse"
          startPoint: WorktreeStartPoint
          type: "newBranch"
      }
    | {
          branchName: string
          type: "existingBranch"
      }
    | {
          startPoint: WorktreeStartPoint
          type: "detached"
      }

export type WorktreeRequest = {
    checkout: WorktreeCheckout
    cwd?: string
    repositoryPath?: string
    workingChanges?: WorktreeWorkingChangesRequest
    worktreePath: string
}

export type WorktreeStartPoint =
    | {
          dirtyPolicy: "allow" | "reject"
          type: "head"
      }
    | {
          ref: string
          type: "ref"
      }

export type WorktreeWarning = {
    code: "source_dirty"
    summary: GitSummary
}

export type WorktreeWorkingChangesRequest = {
    backupMessage: string
    mode: "move"
}

export type WorktreeWorkingChangesResult = {
    backupCommit: string
    backupMessage: string
    failed: number
    firstErrors: Array<string>
    mode: "moved"
    requested: number
    succeeded: number
}

export interface NestMethodMap {
    "appData.delete": { params: AppDataDeleteParams; result: AppDataDeleteResult }
    "appData.get": { params: AppDataGetParams; result: AppDataGetResult }
    "appData.list": { params: AppDataListParams; result: AppDataListResult }
    "appData.set": { params: AppDataSetParams; result: AppDataSetResult }
    "attachment.delete": { params: AttachmentDeleteParams; result: AttachmentDeleteResult }
    "attachment.list": { params: AttachmentListParams; result: AttachmentListResult }
    "attachment.read": { params: AttachmentReadParams; result: AttachmentReadResult }
    "audit.query": { params: AuditQueryParams; result: AuditQueryResult }
    "audit.verify": { params: AuditVerifyParams; result: AuditVerifyResult }
    "auth.pairing.start": { params: AuthPairingStartParams; result: AuthPairingStartResult }
    "auth.principal.delete": { params: AuthPrincipalDeleteParams; result: AuthPrincipalDeleteResult }
    "auth.principal.list": { params: AuthPrincipalListParams; result: AuthPrincipalListResult }
    "auth.principal.pause": { params: AuthPrincipalPauseParams; result: AuthPrincipalPauseResult }
    "auth.principal.read": { params: AuthPrincipalReadParams; result: AuthPrincipalReadResult }
    "auth.principal.upsert": { params: AuthPrincipalUpsertParams; result: AuthPrincipalUpsertResult }
    "auth.token.list": { params: AuthTokenListParams; result: AuthTokenListResult }
    "auth.token.revoke": { params: AuthTokenRevokeParams; result: AuthTokenRevokeResult }
    "auth.token.revokeSelf": { params: AuthTokenRevokeSelfParams; result: AuthTokenRevokeSelfResult }
    "client.tool.result": { params: ClientToolResultParams; result: ClientToolResultResult }
    "fs.copy": { params: FsCopyParams; result: FsCopyResult }
    "fs.describe": { params: FsDescribeParams; result: FsDescribeResult }
    "fs.mkdir": { params: FsMkdirParams; result: FsMkdirResult }
    "fs.move": { params: FsMoveParams; result: FsMoveResult }
    "fs.read": { params: FsReadParams; result: FsReadResult }
    "fs.remove": { params: FsRemoveParams; result: FsRemoveResult }
    "fs.search.content": { params: FsSearchContentParams; result: FsSearchContentResult }
    "fs.search.files": { params: FsSearchFilesParams; result: FsSearchFilesResult }
    "fs.search.glob": { params: FsSearchGlobParams; result: FsSearchGlobResult }
    "fs.watch.list": { params: FsWatchListParams; result: FsWatchListResult }
    "fs.watch.start": { params: FsWatchStartParams; result: FsWatchStartResult }
    "fs.watch.stop": { params: FsWatchStopParams; result: FsWatchStopResult }
    "fs.write": { params: FsWriteParams; result: FsWriteResult }
    "fs.write.fromAttachment": { params: FsWriteFromAttachmentParams; result: FsWriteFromAttachmentResult }
    "git.branch.delete": { params: GitBranchDeleteParams; result: GitBranchDeleteResult }
    "git.branch.isMerged": { params: GitBranchIsMergedParams; result: GitBranchIsMergedResult }
    "git.branch.list": { params: GitBranchListParams; result: GitBranchListResult }
    "git.changed.files": { params: GitChangedFilesParams; result: GitChangedFilesResult }
    "git.commit.cherryCount": { params: GitCommitCherryCountParams; result: GitCommitCherryCountResult }
    "git.commit.count": { params: GitCommitCountParams; result: GitCommitCountResult }
    "git.commit.create": { params: GitCommitCreateParams; result: GitCommitCreateResult }
    "git.commit.files": { params: GitCommitFilesParams; result: GitCommitFilesResult }
    "git.diff.difftastic.read": { params: GitDiffDifftasticReadParams; result: GitDiffDifftasticReadResult }
    "git.file.atTree.read": { params: GitFileAtTreeReadParams; result: GitFileAtTreeReadResult }
    "git.file.list": { params: GitFileListParams; result: GitFileListResult }
    "git.file.pair.read": { params: GitFilePairReadParams; result: GitFilePairReadResult }
    "git.gh.read": { params: GitGhReadParams; result: GitGhReadResult }
    "git.installed.read": { params: GitInstalledReadParams; result: GitInstalledReadResult }
    "git.log.list": { params: GitLogListParams; result: GitLogListResult }
    "git.mergeBase.read": { params: GitMergeBaseReadParams; result: GitMergeBaseReadResult }
    "git.patch.commitFile.read": { params: GitPatchCommitFileReadParams; result: GitPatchCommitFileReadResult }
    "git.patch.worktree.read": { params: GitPatchWorktreeReadParams; result: GitPatchWorktreeReadResult }
    "git.patch.worktreeFile.read": { params: GitPatchWorktreeFileReadParams; result: GitPatchWorktreeFileReadResult }
    "git.repository.init": { params: GitRepositoryInitParams; result: GitRepositoryInitResult }
    "git.repository.path.clone": { params: GitRepositoryPathCloneParams; result: GitRepositoryPathCloneResult }
    "git.repository.path.init": { params: GitRepositoryPathInitParams; result: GitRepositoryPathInitResult }
    "git.repository.path.read": { params: GitRepositoryPathReadParams; result: GitRepositoryPathReadResult }
    "git.repository.read": { params: GitRepositoryReadParams; result: GitRepositoryReadResult }
    "git.status.read": { params: GitStatusReadParams; result: GitStatusReadResult }
    "git.status.summary": { params: GitStatusSummaryParams; result: GitStatusSummaryResult }
    "git.worktree.create": { params: GitWorktreeCreateParams; result: GitWorktreeCreateResult }
    "git.worktree.delete": { params: GitWorktreeDeleteParams; result: GitWorktreeDeleteResult }
    "git.worktree.list": { params: GitWorktreeListParams; result: GitWorktreeListResult }
    "host.binary.check": { params: HostBinaryCheckParams; result: HostBinaryCheckResult }
    "host.binary.list": { params: HostBinaryListParams; result: HostBinaryListResult }
    "host.file.describe": { params: HostFileDescribeParams; result: HostFileDescribeResult }
    "host.path.mkdir": { params: HostPathMkdirParams; result: HostPathMkdirResult }
    "host.path.resolve": { params: HostPathResolveParams; result: HostPathResolveResult }
    "host.platform.read": { params: HostPlatformReadParams; result: HostPlatformReadResult }
    "listener.create": { params: ListenerCreateParams; result: ListenerCreateResult }
    "listener.delete": { params: ListenerDeleteParams; result: ListenerDeleteResult }
    "listener.list": { params: ListenerListParams; result: ListenerListResult }
    "listener.update": { params: ListenerUpdateParams; result: ListenerUpdateResult }
    "permission.respond": { params: PermissionRespondParams; result: PermissionRespondResult }
    "process.batch.start": { params: ProcessBatchStartParams; result: ProcessBatchStartResult }
    "process.command.start": { params: ProcessCommandStartParams; result: ProcessCommandStartResult }
    "process.list": { params: ProcessListParams; result: ProcessListResult }
    "process.output.read": { params: ProcessOutputReadParams; result: ProcessOutputReadResult }
    "process.read": { params: ProcessReadParams; result: ProcessReadResult }
    "process.restart": { params: ProcessRestartParams; result: ProcessRestartResult }
    "process.script.start": { params: ProcessScriptStartParams; result: ProcessScriptStartResult }
    "process.stop": { params: ProcessStopParams; result: ProcessStopResult }
    "process.stopAll": { params: ProcessStopAllParams; result: ProcessStopAllResult }
    "provider.accountUsage.read": { params: ProviderAccountUsageReadParams; result: ProviderAccountUsageReadResult }
    "provider.command.list": { params: ProviderCommandListParams; result: ProviderCommandListResult }
    "provider.list": { params: ProviderListParams; result: ProviderListResult }
    "provider.model.list": { params: ProviderModelListParams; result: ProviderModelListResult }
    "provider.query.run": { params: ProviderQueryRunParams; result: ProviderQueryRunResult }
    "provider.status": { params: ProviderStatusParams; result: ProviderStatusResult }
    "provider.update.run": { params: ProviderUpdateRunParams; result: ProviderUpdateRunResult }
    "runtime.list": { params: RuntimeListParams; result: RuntimeListResult }
    "runtime.read": { params: RuntimeReadParams; result: RuntimeReadResult }
    "schedule.create": { params: ScheduleCreateParams; result: ScheduleCreateResult }
    "schedule.delete": { params: ScheduleDeleteParams; result: ScheduleDeleteResult }
    "schedule.followup.cancel": { params: ScheduleFollowupCancelParams; result: ScheduleFollowupCancelResult }
    "schedule.followup.cancelAll": { params: ScheduleFollowupCancelAllParams; result: ScheduleFollowupCancelAllResult }
    "schedule.followup.create": { params: ScheduleFollowupCreateParams; result: ScheduleFollowupCreateResult }
    "schedule.followup.list": { params: ScheduleFollowupListParams; result: ScheduleFollowupListResult }
    "schedule.followup.read": { params: ScheduleFollowupReadParams; result: ScheduleFollowupReadResult }
    "schedule.followup.runNow": { params: ScheduleFollowupRunNowParams; result: ScheduleFollowupRunNowResult }
    "schedule.followup.update": { params: ScheduleFollowupUpdateParams; result: ScheduleFollowupUpdateResult }
    "schedule.list": { params: ScheduleListParams; result: ScheduleListResult }
    "session.context.read": { params: SessionContextReadParams; result: SessionContextReadResult }
    "session.context.set": { params: SessionContextSetParams; result: SessionContextSetResult }
    "session.create": { params: SessionCreateParams; result: SessionCreateResult }
    "session.delete": { params: SessionDeleteParams; result: SessionDeleteResult }
    "session.discover": { params: SessionDiscoverParams; result: SessionDiscoverResult }
    "session.event.list": { params: SessionEventListParams; result: SessionEventListResult }
    "session.event.search": { params: SessionEventSearchParams; result: SessionEventSearchResult }
    "session.event.search.delete": { params: SessionEventSearchDeleteParams; result: SessionEventSearchDeleteResult }
    "session.fork": { params: SessionForkParams; result: SessionForkResult }
    "session.list": { params: SessionListParams; result: SessionListResult }
    "session.output.read": { params: SessionOutputReadParams; result: SessionOutputReadResult }
    "session.read": { params: SessionReadParams; result: SessionReadResult }
    "session.reconcile": { params: SessionReconcileParams; result: SessionReconcileResult }
    "session.turn.cancel": { params: SessionTurnCancelParams; result: SessionTurnCancelResult }
    "session.turn.interrupt": { params: SessionTurnInterruptParams; result: SessionTurnInterruptResult }
    "session.turn.list": { params: SessionTurnListParams; result: SessionTurnListResult }
    "session.turn.live.list": { params: SessionTurnLiveListParams; result: SessionTurnLiveListResult }
    "session.turn.read": { params: SessionTurnReadParams; result: SessionTurnReadResult }
    "session.turn.start": { params: SessionTurnStartParams; result: SessionTurnStartResult }
    "session.turn.steer": { params: SessionTurnSteerParams; result: SessionTurnSteerResult }
    "session.update": { params: SessionUpdateParams; result: SessionUpdateResult }
    "session.usage.read": { params: SessionUsageReadParams; result: SessionUsageReadResult }
    "session.worktree.create": { params: SessionWorktreeCreateParams; result: SessionWorktreeCreateResult }
    "session.worktree.move": { params: SessionWorktreeMoveParams; result: SessionWorktreeMoveResult }
    "system.capabilities.read": { params: SystemCapabilitiesReadParams; result: SystemCapabilitiesReadResult }
    "system.descriptor.read": { params: SystemDescriptorReadParams; result: SystemDescriptorReadResult }
    "system.initialize": { params: SystemInitializeParams; result: SystemInitializeResult }
    "system.metrics.read": { params: SystemMetricsReadParams; result: SystemMetricsReadResult }
    "system.request.cancel": { params: SystemRequestCancelParams; result: SystemRequestCancelResult }
    "system.status.read": { params: SystemStatusReadParams; result: SystemStatusReadResult }
    "system.subscription.update": { params: SystemSubscriptionUpdateParams; result: SystemSubscriptionUpdateResult }
    "terminal.list": { params: TerminalListParams; result: TerminalListResult }
    "terminal.read": { params: TerminalReadParams; result: TerminalReadResult }
    "terminal.resize": { params: TerminalResizeParams; result: TerminalResizeResult }
    "terminal.spawn": { params: TerminalSpawnParams; result: TerminalSpawnResult }
    "terminal.stop": { params: TerminalStopParams; result: TerminalStopResult }
    "terminal.write": { params: TerminalWriteParams; result: TerminalWriteResult }
    "workspace.create": { params: WorkspaceCreateParams; result: WorkspaceCreateResult }
    "workspace.delete": { params: WorkspaceDeleteParams; result: WorkspaceDeleteResult }
    "workspace.discover": { params: WorkspaceDiscoverParams; result: WorkspaceDiscoverResult }
    "workspace.list": { params: WorkspaceListParams; result: WorkspaceListResult }
    "workspace.read": { params: WorkspaceReadParams; result: WorkspaceReadResult }
    "workspace.register": { params: WorkspaceRegisterParams; result: WorkspaceRegisterResult }
    "workspace.update": { params: WorkspaceUpdateParams; result: WorkspaceUpdateResult }
}

export interface NestMethodParamRequirementMap {
    "appData.delete": true
    "appData.get": false
    "appData.list": true
    "appData.set": true
    "attachment.delete": true
    "attachment.list": false
    "attachment.read": true
    "audit.query": false
    "audit.verify": false
    "auth.pairing.start": false
    "auth.principal.delete": true
    "auth.principal.list": false
    "auth.principal.pause": true
    "auth.principal.read": false
    "auth.principal.upsert": false
    "auth.token.list": false
    "auth.token.revoke": true
    "auth.token.revokeSelf": false
    "client.tool.result": true
    "fs.copy": true
    "fs.describe": true
    "fs.mkdir": true
    "fs.move": true
    "fs.read": true
    "fs.remove": true
    "fs.search.content": true
    "fs.search.files": true
    "fs.search.glob": true
    "fs.watch.list": false
    "fs.watch.start": true
    "fs.watch.stop": true
    "fs.write": true
    "fs.write.fromAttachment": true
    "git.branch.delete": true
    "git.branch.isMerged": true
    "git.branch.list": true
    "git.changed.files": true
    "git.commit.cherryCount": true
    "git.commit.count": true
    "git.commit.create": true
    "git.commit.files": true
    "git.diff.difftastic.read": true
    "git.file.atTree.read": true
    "git.file.list": true
    "git.file.pair.read": true
    "git.gh.read": false
    "git.installed.read": false
    "git.log.list": true
    "git.mergeBase.read": true
    "git.patch.commitFile.read": true
    "git.patch.worktree.read": true
    "git.patch.worktreeFile.read": true
    "git.repository.init": true
    "git.repository.path.clone": true
    "git.repository.path.init": true
    "git.repository.path.read": true
    "git.repository.read": true
    "git.status.read": true
    "git.status.summary": true
    "git.worktree.create": true
    "git.worktree.delete": true
    "git.worktree.list": true
    "host.binary.check": true
    "host.binary.list": false
    "host.file.describe": true
    "host.path.mkdir": true
    "host.path.resolve": true
    "host.platform.read": false
    "listener.create": true
    "listener.delete": true
    "listener.list": false
    "listener.update": true
    "permission.respond": true
    "process.batch.start": true
    "process.command.start": false
    "process.list": false
    "process.output.read": false
    "process.read": true
    "process.restart": true
    "process.script.start": false
    "process.stop": true
    "process.stopAll": false
    "provider.accountUsage.read": true
    "provider.command.list": true
    "provider.list": false
    "provider.model.list": true
    "provider.query.run": true
    "provider.status": true
    "provider.update.run": false
    "runtime.list": false
    "runtime.read": true
    "schedule.create": true
    "schedule.delete": true
    "schedule.followup.cancel": true
    "schedule.followup.cancelAll": true
    "schedule.followup.create": true
    "schedule.followup.list": false
    "schedule.followup.read": true
    "schedule.followup.runNow": true
    "schedule.followup.update": true
    "schedule.list": false
    "session.context.read": true
    "session.context.set": true
    "session.create": true
    "session.delete": true
    "session.discover": false
    "session.event.list": true
    "session.event.search": true
    "session.event.search.delete": true
    "session.fork": true
    "session.list": false
    "session.output.read": true
    "session.read": true
    "session.reconcile": true
    "session.turn.cancel": true
    "session.turn.interrupt": true
    "session.turn.list": true
    "session.turn.live.list": false
    "session.turn.read": true
    "session.turn.start": true
    "session.turn.steer": true
    "session.update": true
    "session.usage.read": true
    "session.worktree.create": true
    "session.worktree.move": true
    "system.capabilities.read": false
    "system.descriptor.read": false
    "system.initialize": true
    "system.metrics.read": false
    "system.request.cancel": true
    "system.status.read": false
    "system.subscription.update": false
    "terminal.list": false
    "terminal.read": false
    "terminal.resize": true
    "terminal.spawn": false
    "terminal.stop": true
    "terminal.write": true
    "workspace.create": false
    "workspace.delete": true
    "workspace.discover": false
    "workspace.list": false
    "workspace.read": true
    "workspace.register": true
    "workspace.update": true
}

export interface NestNotificationMap {
    "appData.changed": AppDataChangedNotification
    "client.tool.call": ClientToolCallNotification
    "client.tool.cancel": ClientToolCancelNotification
    "fs.watch.event": FsWatchEventNotification
    "fs.watch.overflow": FsWatchOverflowNotification
    "permission.request": PermissionRequestNotification
    "process.exited": ProcessExitedNotification
    "process.output": ProcessOutputNotification
    "process.started": ProcessStartedNotification
    "process.stopped": ProcessStoppedNotification
    "runtime.output": RuntimeOutputNotification
    "schedule.fired": ScheduleFiredNotification
    "schedule.updated": ScheduleUpdatedNotification
    "session.created": SessionCreatedNotification
    "session.deleted": SessionDeletedNotification
    "session.event.appended": SessionEventAppendedNotification
    "session.reconciled": SessionReconciledNotification
    "session.turn.updated": SessionTurnUpdatedNotification
    "session.updated": SessionUpdatedNotification
    "terminal.exited": TerminalExitedNotification
    "terminal.output": TerminalOutputNotification
    "terminal.started": TerminalStartedNotification
    "terminal.stopped": TerminalStoppedNotification
    "workspace.updated": WorkspaceUpdatedNotification
}

export type NestMethod = keyof NestMethodMap
export type NestMethodParams<M extends NestMethod> = NestMethodMap[M]["params"]
export type NestMethodResult<M extends NestMethod> = NestMethodMap[M]["result"]
export type NestMethodRequiresParams<M extends NestMethod> = NestMethodParamRequirementMap[M]

export type NestNotificationMethod = keyof NestNotificationMap
export type NestNotificationParams<M extends NestNotificationMethod> = NestNotificationMap[M]

export const NEST_NOTIFICATION_METHODS = [
    "appData.changed",
    "client.tool.call",
    "client.tool.cancel",
    "fs.watch.event",
    "fs.watch.overflow",
    "permission.request",
    "process.exited",
    "process.output",
    "process.started",
    "process.stopped",
    "runtime.output",
    "schedule.fired",
    "schedule.updated",
    "session.created",
    "session.deleted",
    "session.event.appended",
    "session.reconciled",
    "session.turn.updated",
    "session.updated",
    "terminal.exited",
    "terminal.output",
    "terminal.started",
    "terminal.stopped",
    "workspace.updated",
] as const
export const NEST_ERROR_CODES = [
    "already_exists",
    "bad_params",
    "busy",
    "cancelled",
    "conflict",
    "cross_device",
    "deadline_exceeded",
    "directory_not_empty",
    "forbidden",
    "internal",
    "invalid_offset",
    "invalid_params",
    "invalid_request",
    "is_directory",
    "not_directory",
    "not_found",
    "path_escape",
    "payload_too_large",
    "permission_denied",
    "provider_unavailable",
    "queue_full",
    "unauthorized",
    "unsupported_capability",
    "value_too_large",
    "version_conflict",
    "version_mismatch",
] as const
export type NestKnownErrorCode = (typeof NEST_ERROR_CODES)[number]
export type NestErrorCode = NestKnownErrorCode | "unknown"
export const NEST_DESCRIPTOR_VERSION = "2026-09-04.1"
